import SaveIcon from '@mui/icons-material/Save';
import { LoadingButton } from '@mui/lab';

import GoogleLogo from '../../../../assets/icons/googleLogo.svg?react';
import { theme } from '../../../../theme/ThemeProvider';
import { AuthButtonProps } from './types';

export const AuthButton: React.FC<AuthButtonProps> = ({
  text,
  onClick,
  loading,
}) => {
  return (
    <LoadingButton
      startIcon={loading ? <SaveIcon /> : <GoogleLogo />}
      loading={loading}
      variant="contained"
      loadingPosition="start"
      onClick={onClick}
      sx={() => ({
        backgroundColor: theme.palette.common.white,
        padding: '8px 0',
        marginTop: '20px',
      })}
    >
      {text}
    </LoadingButton>
  );
};
